var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { ref: "container" },
    [
      _c(
        "a-modal",
        {
          staticStyle: { top: "100px" },
          attrs: {
            title: _vm.title,
            width: 700,
            visible: _vm.visible,
            confirmLoading: _vm.confirmLoading,
            getContainer: () => _vm.$refs.container,
            maskStyle: { top: "93px", left: "154px" },
            mask: _vm.isDesktop(),
            maskClosable: false,
            cancelText: "取消",
            okText: "保存",
          },
          on: { ok: _vm.handleOk, cancel: _vm.handleCancel },
        },
        [
          _c(
            "a-spin",
            { attrs: { spinning: _vm.confirmLoading } },
            [
              _c(
                "a-form",
                { attrs: { form: _vm.form } },
                [
                  _c(
                    "a-row",
                    { attrs: { gutter: 24 } },
                    [
                      _c(
                        "a-col",
                        { attrs: { span: 12 } },
                        [
                          _c(
                            "a-form-item",
                            {
                              attrs: {
                                labelCol: _vm.labelCol,
                                wrapperCol: _vm.wrapperCol,
                                label: "等级名称",
                              },
                            },
                            [
                              _c("a-input", {
                                directives: [
                                  {
                                    name: "decorator",
                                    rawName: "v-decorator.trim",
                                    value: ["name", _vm.validatorRules.name],
                                    expression: "['name', validatorRules.name]",
                                    modifiers: { trim: true },
                                  },
                                ],
                                attrs: { placeholder: "请输入等级名称" },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "a-col",
                        { attrs: { span: 12 } },
                        [
                          _c(
                            "a-form-item",
                            {
                              attrs: {
                                labelCol: _vm.labelCol,
                                wrapperCol: _vm.wrapperCol,
                                label: "排序(小→高)",
                              },
                            },
                            [
                              _c("a-input-number", {
                                directives: [
                                  {
                                    name: "decorator",
                                    rawName: "v-decorator",
                                    value: ["sort", _vm.validatorRules.sort],
                                    expression: "['sort', validatorRules.sort]",
                                  },
                                ],
                                staticStyle: { width: "100%" },
                                attrs: {
                                  min: 1,
                                  placeholder: "数字越小等级越低",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "a-row",
                    { attrs: { gutter: 24 } },
                    [
                      _c(
                        "a-col",
                        { attrs: { span: 12 } },
                        [
                          _c(
                            "a-form-item",
                            {
                              attrs: {
                                labelCol: _vm.labelCol,
                                wrapperCol: _vm.wrapperCol,
                                label: "升级门槛",
                              },
                            },
                            [
                              _c("a-input-number", {
                                directives: [
                                  {
                                    name: "decorator",
                                    rawName: "v-decorator",
                                    value: [
                                      "upgradeAmount",
                                      _vm.validatorRules.upgradeAmount,
                                    ],
                                    expression:
                                      "['upgradeAmount', validatorRules.upgradeAmount]",
                                  },
                                ],
                                staticStyle: { width: "100%" },
                                attrs: {
                                  min: 0,
                                  precision: 2,
                                  placeholder: "累计零售实付金额",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "a-col",
                        { attrs: { span: 12 } },
                        [
                          _c(
                            "a-form-item",
                            {
                              attrs: {
                                labelCol: _vm.labelCol,
                                wrapperCol: _vm.wrapperCol,
                                label: "保级金额",
                              },
                            },
                            [
                              _c("a-input-number", {
                                directives: [
                                  {
                                    name: "decorator",
                                    rawName: "v-decorator",
                                    value: ["keepAmount"],
                                    expression: "['keepAmount']",
                                  },
                                ],
                                staticStyle: { width: "100%" },
                                attrs: {
                                  min: 0,
                                  precision: 2,
                                  placeholder: "滚动12个月内实付",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "a-row",
                    { attrs: { gutter: 24 } },
                    [
                      _c(
                        "a-col",
                        { attrs: { span: 12 } },
                        [
                          _c(
                            "a-form-item",
                            {
                              attrs: {
                                labelCol: _vm.labelCol,
                                wrapperCol: _vm.wrapperCol,
                                label: "折扣率",
                              },
                            },
                            [
                              _c("a-input-number", {
                                directives: [
                                  {
                                    name: "decorator",
                                    rawName: "v-decorator",
                                    value: ["discountRate"],
                                    expression: "['discountRate']",
                                  },
                                ],
                                staticStyle: { width: "100%" },
                                attrs: {
                                  min: 1,
                                  max: 99,
                                  precision: 0,
                                  placeholder: "如 98 表示98折",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "a-col",
                        { attrs: { span: 12 } },
                        [
                          _c(
                            "a-form-item",
                            {
                              attrs: {
                                labelCol: _vm.labelCol,
                                wrapperCol: _vm.wrapperCol,
                                label: "积分倍率(P1生效)",
                              },
                            },
                            [
                              _c("a-input-number", {
                                directives: [
                                  {
                                    name: "decorator",
                                    rawName: "v-decorator",
                                    value: ["pointMultiple"],
                                    expression: "['pointMultiple']",
                                  },
                                ],
                                staticStyle: { width: "100%" },
                                attrs: {
                                  min: 0.1,
                                  precision: 1,
                                  placeholder: "默认 1.0",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "a-row",
                    { attrs: { gutter: 24 } },
                    [
                      _c(
                        "a-col",
                        { attrs: { span: 12 } },
                        [
                          _c(
                            "a-form-item",
                            {
                              attrs: {
                                labelCol: _vm.labelCol,
                                wrapperCol: _vm.wrapperCol,
                                label: "生日礼类型",
                              },
                            },
                            [
                              _c(
                                "a-select",
                                {
                                  directives: [
                                    {
                                      name: "decorator",
                                      rawName: "v-decorator",
                                      value: ["birthdayType"],
                                      expression: "['birthdayType']",
                                    },
                                  ],
                                  attrs: {
                                    placeholder: "请选择（可不选）",
                                    "allow-clear": "",
                                  },
                                },
                                [
                                  _c(
                                    "a-select-option",
                                    { attrs: { value: "points" } },
                                    [_vm._v("积分")]
                                  ),
                                  _c(
                                    "a-select-option",
                                    { attrs: { value: "coupon" } },
                                    [_vm._v("优惠券")]
                                  ),
                                  _c(
                                    "a-select-option",
                                    { attrs: { value: "discount" } },
                                    [_vm._v("折扣")]
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "a-col",
                        { attrs: { span: 12 } },
                        [
                          _c(
                            "a-form-item",
                            {
                              attrs: {
                                labelCol: _vm.labelCol,
                                wrapperCol: _vm.wrapperCol,
                                label: "生日礼范围",
                              },
                            },
                            [
                              _c(
                                "a-select",
                                {
                                  directives: [
                                    {
                                      name: "decorator",
                                      rawName: "v-decorator",
                                      value: ["birthdayScope"],
                                      expression: "['birthdayScope']",
                                    },
                                  ],
                                  attrs: {
                                    placeholder: "请选择（可不选）",
                                    "allow-clear": "",
                                  },
                                },
                                [
                                  _c(
                                    "a-select-option",
                                    { attrs: { value: "day" } },
                                    [_vm._v("生日当天")]
                                  ),
                                  _c(
                                    "a-select-option",
                                    { attrs: { value: "month" } },
                                    [_vm._v("生日当月")]
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }